
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Button/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Button/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Container/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Container/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller2 from '/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Preview/viewer.controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Preview/model.ts';
            var controllerExport2 = _controllerExport2;
            

  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: '',
      id: 'undefined',
      projectName: 'pdf-viewer-bob',
      teamName: '',
      errorMonitor: true,
    };

  var experimentsConfig = {"centralized":true,"scopes":[]};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"app.settings.label":"PDF Viewer","app.settings.upload.pdf":"Upload PDF","app.settings.gfpp.settings":"Settings","app.settings.upload.pdf.button.label":"Change File","app.settings.print.label":"Let visitors print the file","app.settings.download.label":"Let visitors download the file","app.settings.display.page.text":"Which page is displayed first?","app.layout.gfpp.settings.label":"Settings","app.settings.add.pdf.button.label":"Add File","app.settings.upload.pdf.label":"Upload a PDF file and display it on your site.","app.settings.upload.pdf.error.message":"This file type isn’t supported. Upload a file in PDF format.","app.settings.gfpp.label.input.file":"File name","app.settings.gfpp.radio.label":"Select a view:","app.settings.gfpp.radio.single.page":"Single-page view","app.settings.gfpp.dropdown.fit.width":"Fit to width","app.settings.gfpp.dropdown.zoom.to.page":"Fit to height","app.settings.gfpp.radio.two.page":"Two-page view","app.settings.gfpp.toggle.button":"Show left sidebar","app.settings.gfpp.zoom.label":"Set zoom","app.settings.gfpp.layout":"Layout","app.settings.gfpp.layout.title.available":"Layout can’t be changed","app.settings.gfpp.layout.description.available":"See other presets for more customization options.","app.settings.gfpp.design":"Design","app.settings.gfpp.design.title.available":"Design can’t be changed","app.settings.gfpp.design.description.available":"See other presets for more customization options.","app.settings.gfpp.presets.full.window":"Full window","app.settings.gfpp.presets.sized.container":"Sized container","app.settings.gfpp.presets.in.line":"In-line","app.settings.gfpp.presets.thumbnail":"Text & button","app.settings.gfpp.presets.document.button":"Document button","app.settings.gfpp.presets.classic.button":"Classic button","app.settings.gfpp.text.edit.text":"Edit Text","app.settings.gfpp.pdf.name":"PDF name","app.settings.gfpp.input.start.page.error.message":"Enter a valid number.","app.settings.inner.layout.gfpp":"Change Text & Icon","app.settings.remove.pdf.button.label":"Remove File"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "pdf-viewer-bob",
    biConfig: null,
    appName: "PDF viewer",
    appDefinitionId: "89ad9892-2932-455c-9828-10eb93407be9",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Button/viewer.controller.ts",
          appName: "PDF viewer",
          appDefinitionId: "89ad9892-2932-455c-9828-10eb93407be9",
          projectName: "pdf-viewer-bob",
          componentName: "Button",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "89ad9892-2932-455c-9828-10eb93407be9-zxjkk" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Container/viewer.controller.ts",
          appName: "PDF viewer",
          appDefinitionId: "89ad9892-2932-455c-9828-10eb93407be9",
          projectName: "pdf-viewer-bob",
          componentName: "Container",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "89ad9892-2932-455c-9828-10eb93407be9-lfyze" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/9be9f68801a766ef/packages/pdf-viewer-bob/src/components/Preview/viewer.controller.ts",
          appName: "PDF viewer",
          appDefinitionId: "89ad9892-2932-455c-9828-10eb93407be9",
          projectName: "pdf-viewer-bob",
          componentName: "Preview",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "89ad9892-2932-455c-9828-10eb93407be9-o9sr8" }],
    false);

    export const createControllers = _createControllers
